import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-memorandum-datetime-picker',
  templateUrl: './memorandum-datetime-picker.component.html',
  styleUrls: ['./memorandum-datetime-picker.component.scss'],
})
export class MemorandumDatetimePickerComponent implements OnInit {
  @Input() value: string = '';

  datetimeValue: string = '';

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    this.datetimeValue = this.value || '';
  }

  dismiss() {
    this.modalController.dismiss();
  }

  confirm() {
    this.modalController.dismiss({ value: this.datetimeValue }, 'confirm');
  }
}
